import React, { useState } from "react";
import { Formik } from "formik";
import SelectDropdown from "../../../../../components/common-components/selectDropdown";
import Input from "../../../../../components/common-components/input/Input";
import Button from "../../../../../components/common-components/button/Button";
import { BUTTON_VARIANTS } from "../../../../../components/common-components/button/Constants";
import ModalComponent from "../../../../../components/common-components/modal/ModalComponent";
import { CARE_PLAN_STATUS, CARE_PLAN_INTENT } from "../Constants";
import ItemManager from "../ItemManager";
// import Appointment from "./Appointment";
import HealthRecordHelper from "../utils/utils";

const CarePlan = ({ open, close, onConfirm }) => {
    // const [appointmentList, setAppointmentList] = useState([]);
    // const [isAppointmentPopupOpen, setIsAppointmentPopupOpen] = useState(false);
    const validate = (values) => {
        const errors = {};
        if (!values.carePlanStatus || values.carePlanStatus.value === "Select Status") {
            errors.carePlanStatus = "Please select a care plan status.";
        }
        if (!values.carePlanIntent || values.carePlanIntent.value === "Select Intent") {
            errors.carePlanIntent = "Please select a care plan intent.";
        }
        return errors;
    };

    return (
        <>
            <Formik
                initialValues={{
                    carePlanStatus: { label: "Select Status", value: "Select Status" },
                    carePlanIntent: { label: "Select Intent", value: "Select Intent" },
                    carePlanCategory: "",
                    carePlanDescription:""
                }}
                validate={validate}
                onSubmit={(values) => {
                    const data = {
                        resourceType: "CarePlan",
                        status: values.carePlanStatus.value,
                        intent: values.carePlanIntent.value,
                        description: values.carePlanDescription,
                        category: {
                            text: values.carePlanCategory,
                        },
                        // activity: appointmentList.map((item) => item.data),
                    };
                    const formattedData = HealthRecordHelper.removeEmptyFields(data)
                    onConfirm((prev) => [...prev, { type: `Care Plan Report ${prev.length + 1}`, data: formattedData }]);
                    close();
                }}
            >
                {({ values, errors, setFieldValue, handleSubmit }) => (
                    <ModalComponent
                        open={open}
                        title={"Add Care Plan"}
                        footerButton={
                            <Button
                                variant={BUTTON_VARIANTS.CONTAINED}
                                onClickCb={() => handleSubmit()}
                            >
                                Submit
                            </Button>
                        }
                        close={() => close()}
                        customClasses="w-[90%] max-w-[800px]"
                        hideOverflow={true}
                    >
                        <div className="grid grid-cols-2 gap-4">
                            <SelectDropdown
                                label="Care Plan Status"
                                name="carePlanStatus"
                                customClasses="w-full"
                                isRequired={true}
                                value={values.carePlanStatus}
                                options={[{ label: "Select Status", value: "Select Status" }, ...CARE_PLAN_STATUS]}
                                onChangeCb={(selectedOption) =>
                                    setFieldValue("carePlanStatus", selectedOption)
                                }
                            />
                            <SelectDropdown
                                label="Care Plan Intent"
                                name="carePlanIntent"
                                customClasses="w-full"
                                isRequired={true}
                                value={values.carePlanIntent}
                                options={[{ label: "Select Intent", value: "Select Intent" }, ...CARE_PLAN_INTENT]}
                                onChangeCb={(selectedOption) =>
                                    setFieldValue("carePlanIntent", selectedOption)
                                }
                            />
                            <Input
                                label="Category"
                                placeholder="Enter care plan category"
                                name="carePlanCategory"
                                value={values.carePlanCategory}
                                onChangeCb={(e) => setFieldValue("carePlanCategory", e.target.value)}
                            />
                             <Input
                                label="Description"
                                placeholder="Enter description"
                                name="carePlanDescription"
                                value={values.carePlanDescription}
                                onChangeCb={(e) => setFieldValue("carePlanDescription", e.target.value)}
                            />
                            {/* <ItemManager
                                title={ "Appointments"}
                                items={appointmentList}
                                setItems={setAppointmentList}
                                setIsPopupOpen={setIsAppointmentPopupOpen}
                                customHeight="52"
                                customClass={"col-span-2"}
                            /> */}
                        </div>
                    </ModalComponent>
                )}
            </Formik>
            {/* {isAppointmentPopupOpen && 
                <Appointment
                    open={isAppointmentPopupOpen}
                    onConfirm={setAppointmentList}
                    close={() => setIsAppointmentPopupOpen(false)}
                />
            } */}
        </>
    );
};

export default CarePlan;
